import { Link } from 'react-router-dom';

export default function TermsPage() {
  return (
    <div className="min-h-screen t-bg-page t-text py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8">
          <Link to="/login" className="t-text-accent hover:opacity-80 text-sm t-focus-ring rounded">
            ← Back
          </Link>
          <h1 className="text-3xl font-bold t-text mt-4 mb-1">Terms of Service</h1>
          <p className="t-text-disabled text-sm">Last updated: 14 April 2026</p>
        </div>

        <div className="space-y-10 text-sm leading-relaxed">

          <section aria-labelledby="t1">
            <h2 id="t1" className="text-lg font-semibold t-text mb-3">1. About the service</h2>
            <p>
              That Music Game (&ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;) operates{' '}
              <strong className="t-text">thatmusicgame.com</strong>, an online social game where
              players choose songs, rate them, and predict each other&rsquo;s ratings. By using this
              site you agree to these terms.
            </p>
          </section>

          <section aria-labelledby="t2">
            <h2 id="t2" className="text-lg font-semibold t-text mb-3">2. Accounts</h2>
            <ul className="list-disc list-inside space-y-1.5">
              <li>You must be at least 13 years old to create an account.</li>
              <li>You are responsible for keeping your login credentials secure.</li>
              <li>
                Your username is visible to all signed-in players. Choose something you are
                comfortable sharing.
              </li>
              <li>
                We reserve the right to suspend or delete accounts that violate these terms.
              </li>
            </ul>
          </section>

          <section aria-labelledby="t3">
            <h2 id="t3" className="text-lg font-semibold t-text mb-3">3. Acceptable use</h2>
            <p className="mb-2">You must not use this service to:</p>
            <ul className="list-disc list-inside space-y-1.5">
              <li>Submit usernames or song proposals containing offensive, hateful, or illegal content.</li>
              <li>Attempt to gain unauthorised access to other accounts or game sessions.</li>
              <li>Automate or script interactions in a way that degrades the service for other users.</li>
              <li>Use the service for any unlawful purpose.</li>
            </ul>
          </section>

          <section aria-labelledby="t4">
            <h2 id="t4" className="text-lg font-semibold t-text mb-3">4. Premium features and payments</h2>
            <ul className="list-disc list-inside space-y-1.5">
              <li>
                Some features require a paid subscription or one-off payment, processed by{' '}
                <strong className="t-text">Stripe</strong>.
              </li>
              <li>
                Monthly subscriptions renew automatically. You may cancel at any time from your
                profile page; access continues until the end of the current billing period.
              </li>
              <li>
                90-day access is a one-off payment with no recurring charges. It expires after 90
                days from purchase.
              </li>
              <li>
                We do not offer refunds except where required by law (e.g. UK Consumer Contracts
                Regulations 2013).
              </li>
            </ul>
          </section>

          <section aria-labelledby="t5">
            <h2 id="t5" className="text-lg font-semibold t-text mb-3">5. Third-party services</h2>
            <p className="t-text-muted mb-3">
              The service uses Firebase (Google) for infrastructure, Stripe for payment processing, and
              LiveKit for real-time video and audio relay. We are not affiliated with or endorsed by
              Google, Stripe, or LiveKit.
            </p>
            <p className="t-text-muted">
              During a game, players may optionally enable their camera, microphone, or screen share.
              Real-time media streams are routed through <strong className="t-text-secondary">LiveKit
              Cloud</strong>&rsquo;s infrastructure for the duration of the session — media content is
              not stored by LiveKit or by us. By enabling these features you consent to other players
              in the same game session receiving your video, audio, or screen content for the duration
              of that session only. You must not use screen share or camera features to share unlawful,
              harmful, or infringing content.
            </p>
          </section>

          <section aria-labelledby="t6">
            <h2 id="t6" className="text-lg font-semibold t-text mb-3">6. Intellectual property</h2>
            <p>
              Songs played in the game are the property of their respective rights holders. This
              service does not host or distribute audio files. Players are responsible for ensuring
              they have the right to play music through their chosen platform (e.g. a streaming
              subscription). We accept no liability for copyright or DMCA issues arising from a
              player&rsquo;s choice of music.
            </p>
          </section>

          <section aria-labelledby="t7">
            <h2 id="t7" className="text-lg font-semibold t-text mb-3">7. Disclaimer of warranties</h2>
            <p>
              The service is provided &ldquo;as is&rdquo; without any warranty of any kind. We do
              not guarantee continuous, uninterrupted, or error-free availability. We may update,
              suspend, or discontinue the service at any time without notice.
            </p>
          </section>

          <section aria-labelledby="t8">
            <h2 id="t8" className="text-lg font-semibold t-text mb-3">8. Limitation of liability</h2>
            <p>
              To the fullest extent permitted by law, we are not liable for any indirect, incidental,
              or consequential damages arising from your use of this service.
            </p>
          </section>

          <section aria-labelledby="t9">
            <h2 id="t9" className="text-lg font-semibold t-text mb-3">9. Governing law</h2>
            <p>
              These terms are governed by the laws of England and Wales. Any disputes shall be
              subject to the exclusive jurisdiction of the courts of England and Wales.
            </p>
          </section>

          <section aria-labelledby="t10">
            <h2 id="t10" className="text-lg font-semibold t-text mb-3">10. Changes to these terms</h2>
            <p>
              We may update these terms from time to time. Continued use of the service after
              changes are posted constitutes acceptance of the revised terms. The &ldquo;last
              updated&rdquo; date at the top of this page will always reflect the most recent
              version.
            </p>
          </section>

          <section aria-labelledby="t11">
            <h2 id="t11" className="text-lg font-semibold t-text mb-3">11. Contact</h2>
            <p>
              Questions about these terms:{' '}
              <a
                href="mailto:privacy@thatmusicgame.com"
                className="t-text-accent hover:opacity-80 underline t-focus-ring rounded"
              >
                privacy@thatmusicgame.com
              </a>
            </p>
          </section>

        </div>
      </div>
    </div>
  );
}
